import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const DatabaseDownstreamWorkbooksFilteredByTableWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DatabaseDownstreamWorkbooksFilteredByTableWithoutPersonalSpaceQuery(
  $databaseId: ID!,
  $tableId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: WorkbookSortOrder!
) {
  databases(filter: { id: $databaseId }) {
    tables(filter: { id: $tableId }) {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          id
          name
          vizportalUrlId
          description
          projectName
          projectVizportalUrlId
          owner {
            name
            username
            domain
          }
          sheetsConnection {
            totalCount
          }
        }
      }
    }
  }
}
`;
